import { render } from "./ImageZoom.vue?vue&type=template&id=0c2495a6&scoped=true"
import script from "./ImageZoom.vue?vue&type=script&lang=js"
export * from "./ImageZoom.vue?vue&type=script&lang=js"

import "./ImageZoom.vue?vue&type=style&index=0&id=0c2495a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2495a6"]])

export default __exports__